var getNumbersValue = function (value: string) {
  // Return stripped input value — just numbers
  return value.replace(/\D/g, '')
}


export function PhoneInput(inp: any) {
  const onKeyDown = (e:any) => {
    // Clear input after remove last symbol
    var inputValue = getNumbersValue(e.target.value)
    if (e.keyCode === 8 && inputValue.length === 1) {
      inp.value = ''
    }
  }
  const onInput = (e: any) => {

      var input = e.target,
          inputNumbersValue = getNumbersValue(input.value),
          selectionStart = input.selectionStart,
          formattedInputValue = ""
    
      if (!inputNumbersValue) {
          return inp.value = ''
      }
    
      if (input.value.length !== selectionStart) {
          // Editing in the middle of input, not last symbol
          if (e.data && /\D/g.test(e.data)) {
              // Attempt to input non-numeric symbol
              inp.value = (inputNumbersValue);
              return
          }
      }
    
      if (["7", "8", "9"].indexOf(inputNumbersValue[0]) > -1) {
          if (inputNumbersValue[0] === "9") inputNumbersValue = "7" + inputNumbersValue
          var firstSymbols = (inputNumbersValue[0] === "8") ? "8" : "+7"
          formattedInputValue = firstSymbols + " "
          if (inputNumbersValue.length > 1) {
              formattedInputValue += '(' + inputNumbersValue.substring(1, 4)
          }
          if (inputNumbersValue.length >= 5) {
              formattedInputValue += ') ' + inputNumbersValue.substring(4, 7)
          }
          if (inputNumbersValue.length >= 8) {
              formattedInputValue += '-' + inputNumbersValue.substring(7, 9)
          }
          if (inputNumbersValue.length >= 10) {
              formattedInputValue += '-' + inputNumbersValue.substring(9, 11)
          }
      } else {
          formattedInputValue = '+' + inputNumbersValue.substring(0, 16)
      }
      inp.value = (formattedInputValue);
  }

  const onPaste = (e:any) => {
    var input = e.target,
      inputNumbersValue = getNumbersValue(input.value)
      var pasted = e.clipboardData || window.clipboardData
      if (pasted) {
          var pastedText = pasted.getData('Text')
          if (/\D/g.test(pastedText)) {
              // Attempt to paste non-numeric symbol — remove all non-numeric symbols,
              // formatting will be in onPhoneInput handler
              inp.value = (inputNumbersValue)
              return
          }
      }
  }
  inp.addEventListener('input', onInput)
  inp.addEventListener('keydown', onKeyDown)
  inp.addEventListener('paste', onPaste)
}